module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section07_04_american-village-6d479eed18030ffd4dedcc70b83f511d.jpg";